'use strict'

import { InventoryService } from '../services'

const getDefaultState = () => {
    return {
        currentInqProduct: null,
        newProductEntry: undefined,
        isUploadingImage: undefined,
        productFolder: undefined,
        productPrice: [],
        productLotMaster: [],
        isFetchingLots: false
    }
  }

  // initial state
const state = getDefaultState()

const actions = {
    resetState ({ commit }) {
        commit('resetState')
      },
    setProductInq({ commit },product ) {
        return new Promise((res, rej)  => {
            commit("SET_PRODUCT_INQ", product);
            res(true);
        })
    },
    setNewProduct({commit}, product_code){
        return new Promise((res, rej) => {
            commit("SET_NEW_PRODUCT",product_code);
            res(true);
        })
    },
    setProductFolder({ commit }, folder ){
        commit("SET_FOLDER_PRODUCT", folder)
    },
    setUploadImage({ commit }, payload) {
        commit("LOADING_IMAGE", payload);
    },
    getProductPrices({ commit }, product_code) {
        InventoryService.fetchProductPriceList(product_code, 0)
          .then (({ data, status }) => {
            if (status === 200) {
                commit("SET_PRODUCT_PRICE", data)
            }
          })
    },
    prepareUpdatePrice({ commit }, id) {
        commit('PREPARE_PRODUCT_PRICE', id )
    },
    fetchLotMaster({commit}, payload) {
        const { productCode, locationCode } = payload

        commit('setFetching', true)
        return InventoryService.productLotMasterGetList(
            productCode,
            locationCode,
          ).then(({ data }) => {
            data.map(el => {
                el.lot_qty = 0
                el.expiration_date = moment(el.expiration_date).format("YYYY-MM-DD");
                el._v_qty_available = parseFloat(el._v_qty_available).toFixed(el.Product.qty_decimal_position)
            })

            commit('SET_PRODUCT_LOT_MASTER', data.filter(function(el) { return el._v_qty_available > 0}))
          })
          .finally(() => commit('setFetching', false))

    }
}

const mutations = {
    resetState (state) {
        Object.assign(state, getDefaultState())
    },
    setFetching(state, status) {
        state.isFetchingLots = status
    },
    SET_PRODUCT_INQ(state, product) {
        state.currentInqProduct = product;
        state.newProductEntry = null;
        if (!product) state.productPrice = []
    },
    SET_NEW_PRODUCT(state, product_code) {
        state.newProductEntry = product_code;
        state.currentInqProduct = null;
        if (!product_code) state.productPrice = []
    },
    LOADING_IMAGE(state, payload) {
        state.isUploadingImage = payload
    },
    SET_FOLDER_PRODUCT(state, payload) {
        state.productFolder = payload;
    },
    SET_PRODUCT_PRICE(state, payload) {
        state.productPrice = payload
    },
    UPDATE_PRODUCT_PRICE(state, {id, unit_price}) {
        let row = state.productPrice.find(item => item.id == id);
        row.unit_price = unit_price
        row._isEditing = false
    },
    DELETE_PRODUCT_PRICE(state, id){
        let idx = state.productPrice.findIndex(item => item.id == id);
        state.productPrice.splice(idx,1)
    },
    CREATE_PRODUCT_PRICE(state, row) {
        state.productPrice.push(row)
    },
    SET_PRODUCT_LOT_MASTER(state, dataset) {
        state.productLotMaster = dataset
    }
};

const getters = {
    productInquiry: state => {
        return state.currentInqProduct ? true : false;
    },
    newProduct: state => {
        return state.newProductEntry ? true : false;
    },
    currentFolder: state => {
        return state.productFolder;
    },
    productPriceList: state => {
        return state.productPrice
    }
}


export const inventory = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};



// WEBPACK FOOTER //
// ./src/store/inventory.module.js